<template>
    <div>
        <div class="header">
            <h3>{{ $t('payment_data') }}</h3>
        </div>

        <el-button type="primary" class="mb15" @click="create">{{ $t('add_wallet') }}</el-button>

        <el-table
                v-loading="loading"
                :data="data"
                style="width: 100%">

            <el-table-column
                    prop="name"
                    :label="$t('wallet')">
                <template slot-scope="scope">
                    {{  Object.values(scope.row.data).join(', ') }}
                </template>

            </el-table-column>
            <el-table-column
                    prop="payment_system"
                    :label="$t('payment_system')">
                <template slot-scope="scope">
                    {{ scope.row.method.name }}
                </template>
            </el-table-column>
            <el-table-column
                    :label="$t('currency')">
                <template slot-scope="scope">
                    {{ scope.row.method.currency.code }}
                </template>
            </el-table-column>
            <el-table-column
                    width="140">
                <template slot-scope="scope">
                    <el-button-group>
                        <el-button size="mini" @click="edit(scope.row)"><i class="material-icons"></i></el-button>
                        <el-button size="mini" type="danger" @click="remove(scope.row)"><i class="material-icons">&#xe872;</i></el-button>
                    </el-button-group>
                </template>
            </el-table-column>
        </el-table>

        <el-dialog v-on:closed="formReset" :title="model.id ? $t('edit_wallet_title'): $t('add_wallet_title')" :visible.sync="dialogFormVisible">

            <el-form :model="model" status-icon label-width="250px">

                <el-form-item :label="$t('payment_system')" prop="payment_system_id" :error="error_form.method_id">
                    <el-select v-model="model.method_id">
                        <el-option
                                v-for="item in payment_methods"
                                :key="item.id"
                                :label="item.name +' ('+item.currency.code+')'"
                                :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>

                <el-form-item :label="item.label" v-for="(item, index) in schema" :key="index" :error="error_form[index]" v-if="model.method_id">
                    <el-input v-model="model.data[index]" :placeholder="item.placeholder"></el-input>
                </el-form-item>

                <el-form-item :label="$t('current_password')" prop="current_password" :error="error_form.current_password" v-if="model.method_id">
                    <el-input v-model="model.current_password" show-password></el-input>
                </el-form-item>

                <el-form-item v-if="model.method_id">
                    <el-button type="primary" @click="save" :loading="loading_form">{{ model.id ? $t('save'): $t('create') }}</el-button>
                    <el-button @click="dialogFormVisible = false">Cancel</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>
    </div>
</template>

<script>
    export default {
        name: "PaymentWallet",
        data () {
            return {
                data: [],
                loading: false,
                model: {},
                error_form: {},
                dialogFormVisible: false,
                loading_form: false,
                payment_methods: []
            }
        },
        created () {
            this.fetchData();

            this.$axios.get('/payment-methods').then((res) => {
                this.payment_methods = res.data;
            })
        },
        computed: {
            schema() {
                let selectedMethod = this.payment_methods.find(item => item.id === this.model.method_id);
                if (selectedMethod) {
                    return selectedMethod.schema;
                }
            }
        },
        methods: {
            fetchData () {
                this.loading = true;
                this.$axios.get('/payment-wallets').then((res) => {
                    this.data = res.data;
                    this.loading = false;
                })
            },
            formReset () {
                this.model = {
                    id: null,
                    value: '',
                    data: {}
                };
                this.error_form = {};
                this.loading_form = false;
            },
            edit (model) {
                this.dialogFormVisible=true;
                this.error_form = {};
                this.model={
                    id: model.id,
                    value: model.value,
                    method_id: model.method.id,
                    data: Object.assign({}, model.data),
                    current_password: model.current_password
                };
            },
            create () {
                this.dialogFormVisible=true;
                this.formReset();
            },
            save () {
                this.loading_form=true;
                if (this.model.id) {
                    this.$axios.patch('/payment-wallets/' + this.model.id, this.model).then((res) => {
                        this.error_form = {};
                        this.loading_form = false;
                        this.dialogFormVisible=false;
                        this.fetchData()
                    }).catch((error) => {
                        this.error_form = error.response.data;
                        this.loading_form=false;
                    });
                } else {
                    this.$axios.post('/payment-wallets', this.model).then((res) => {
                        this.error_form = {};
                        this.loading_form = false;
                        this.dialogFormVisible=false;
                        this.fetchData()
                    }).catch((error) => {
                        this.error_form = error.response.data;
                        this.loading_form=false;
                    });
                }
            },
            remove (model) {
                this.$confirm(this.$t('confirm_delete_wallet'), this.$t('confirm_title'), {
                    confirmButtonText: 'OK',
                    cancelButtonText: 'Cancel',
                    type: 'warning'
                }).then(() => {
                    this.loading = true;
                    this.$axios.delete('/payment-wallets/' + model.id ).then(() => {
                        this.$message({
                            type: 'success',
                            message: this.$t('notice.wallet_deleted')
                        });
                        //this.fetchData()
                        this.loading = false;
                        this.data.splice(this.data.indexOf(model), 1);
                    });
                }).catch(() => {
                    this.loading = false;
                });
            }
        }
    }
</script>

<style scoped>

</style>